module.exports = __webpack_public_path__ + "static/media/TopDelivery_4.e8a9360a.png";